import { type ProductListResponse } from '../../components/organisms/ProductList/models'
import Api from '../../utils/api'

const DEFAULT_ARGS = {
  currentPage: '1',
  pageSize: '100'
}

const ProductsData: (() => null) & {
  getProductsData(args: {
    cbxUrl: string
    superTags: string
    market: string
    channel: string
    locale?: string
    currentPage?: string
    pageSize?: string
  }): Promise<ProductListResponse>
} = () => null

ProductsData.getProductsData = async ({ ...args }) => {
  const { cbxUrl: url, superTags, market, channel, locale, ...rest } = args

  const headers = {
    'Content-Type': 'application/json'
  }

  const API_PRODUCTS_DATA = {
    url,
    options: {
      method: 'GET',
      headers
    }
  }

  const queryParams = new URLSearchParams({
    ...DEFAULT_ARGS,
    ...(market && { market }),
    ...(channel && { channel }),
    ...(locale && { locale }),
    superTags,
    ...rest
  })

  const productsUrl = `${API_PRODUCTS_DATA.url}/products/v1.0/products?${queryParams}`

  let products = []

  const res = await Api.fetch(productsUrl, API_PRODUCTS_DATA.options)
  const {
    paginationInfo: { currentPage, totalPages },
    facets,
    items
  } = { ...(await res?.json()) }

  products = items

  const nextPage = currentPage + 1
  if (nextPage <= totalPages) {
    const { items: update } = await ProductsData.getProductsData({
      ...args,
      currentPage: nextPage
    })

    products = [...items, ...update]
  }

  return { facets, items: products }
}

export default ProductsData
